import { render, staticRenderFns } from "./IcoSkillsDomainDigitalAi.vue?vue&type=template&id=67ff65db"
import script from "./IcoSkillsDomainDigitalAi.vue?vue&type=script&lang=js"
export * from "./IcoSkillsDomainDigitalAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports